<template>
  <section class="onboarding">
    <div class="onboarding__banner">
      <TopBanner :item="banner" />
    </div>

    <div class="onboarding-header">
      <div class="container _py-12 _px-md-4">
        <!-- <h1 class="_fs-48 _fs-sm-32 _lh-sm-38 _lh-64 _tc-dark _fw-700">
          {{ $t('pages.onboarding.title') }}
        </h1>
        <h3 class="_fs-32 _fs-sm-24 _lh-sm-32 _lh-38 _tc-dark _fw-700 _mt-12">
          {{ $t('pages.onboarding.description') }}
        </h3> -->
        <div class="onboard-filter">
          <div class="onboard-filter__container">
            <div
              class="onboard-filter__item _py-6 _px-8 _mt-6"
              v-for="(item, i) in filter"
              :key="i"
              :class="{
                'onboard-filter__item_active': activeCategory === item.slug,
              }"
            >
              <div
                class="onboard-filter__item-title _fs-18 _fs-sm-20 _lh-sm-24 _lh-32 _tc-dark _fw-700"
              >
                {{ item.name }}
              </div>
              <AppBtn
                class="_mt-4 w-100 w-md-auto _ml-md-auto _ml-sm-0 _mt-sm-4 _mt-md-0"
                @click.native="filterCategory(item)"
                ><span class="_py-2 _px-3 d-flex align-center">
                  <svg
                    class="_mr-2"
                    v-if="activeCategory === item.slug"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="_fs-16 _lh-24 _fw-500">{{
                    activeCategory === item.slug
                      ? $t("pages.onboarding.selected")
                      : $t("pages.onboarding.select")
                  }}</span>
                </span></AppBtn
              >
            </div>
          </div>
        </div>
        <div class="onboarding__items cards _my-12">
          <VideoCard
            @downloadFile="downloadFile"
            v-for="(block, bId) in filteredElements"
            :key="bId"
            :item="block"
            :hideFavorites="true"
          >
          </VideoCard>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppBtn from "@/components/UI/buttons/AppBtn";
// import OnboardingItem from '../components/UI/OnboardingItem.vue'
import TopBanner from "@/components/UI/banners/TopBanner";
import VideoCard from "@/components/UI/cards/VideoCard";
import download from "@/mixins/download";

export default {
  metaInfo() {
    return { title: this.$t("pages.onboarding.title") };
  },
  name: "Onboarding",
  components: {
    AppBtn,
    // OnboardingItem,
    VideoCard,
    TopBanner,
  },
  mixins: [download],
  data: () => ({
    activeCategory: "",
  }),
  computed: {
    filter() {
      return this.$t("pages.onboarding.filter");
    },
    filteredElements() {
      return this.items.filter((el) => el.category === this.activeCategory);
    },
    items() {
      // const vm = this
      return this.$t("pages.onboarding.items");
    },
    banner() {
      return {
        title: this.$t("pages.onboarding.title"),
        descr: this.$t("pages.onboarding.subdescr"),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/mz/MZ-mob.jpg"),
            media: "(max-width: 540px)",
          },
          {
            src: require("@/assets/img/banners/mz/MZ-tab.jpg"),
            media: "(max-width: 1024px)",
          },
          {
            src: require("@/assets/img/banners/mz/MZ-1440.jpg"),
            media: "(max-width: 1440px)",
          },
          {
            src: require("@/assets/img/banners/mz/MZ-1920.jpg"),
            media: "(min-width: 1441px)",
          },
        ],
      };
    },
  },
  created() {
    const hash = window.location.hash;

    const hashValue = hash.slice(1);

    const match = hashValue.match(/intensive(\d+)/);
    const number = match ? parseInt(match[1], 10) : null;
    if (number !== null) {
      let categories = ["new", "hight", "tab"];
      this.activeCategory = categories[number];
    }
  },
  methods: {
    filterCategory(category) {
      this.activeCategory = category.slug;
      if (this.$gtm) {
        this.$gtm.push({
          event: "onboarding_user_category",
          param_value: this.helpers.stripHtml(category.name),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.onboard-filter {
  &__container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
    }
  }
  &__item {
    background-color: color(light);
    border-radius: 16px;
    border: 1px solid #d1d2cd;

    @media screen and (max-width: 1220px) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    @media screen and (max-width: 743px) {
      display: block;
    }

    &_active {
      background-color: #ebf6e3;
      border-color: #77bb2f;
    }
  }
}
</style>

<style lang="scss">
.onboarding {
  &-item {
    .resized img {
      @media screen and (max-width: 375px) {
        max-width: 100%;
      }
    }
    svg {
      flex-shrink: 0;
    }
  }
  &__banner {
    background-color: #EBF6E3;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}

.cards {
  width: 50%;

  @media screen and (max-width: 1220px) {
    width: 100%;
  }
}
</style>
